import React from 'react';
import { Spin, Tabs } from 'antd';
import { useGetAllDomain } from '../../../query/domain-warmup';
import PreWarmedUpDomain from './PreWarmedUpDomain';
import WarmedUpDomain from './WarmedUpDomain';
import CreateNewDomainButton from './components/CreateNewDomainButton';

const { TabPane } = Tabs;

export default function DomainWarmUp() {
  const {
    data: { data: domains },
    isLoading,
  } = useGetAllDomain();
  const populatedDomains = populateDefaultDomains(domains);
  const preWarmedUpDomains = populatedDomains.filter(e => !e.isWarmedUp);
  const warmedUpDomains = populatedDomains.filter(e => e.isWarmedUp);
  const percentageKey = warmedUpDomains.map(e => ({
    domain: e.name,
    percentage: e.percentageDistribution,
  }));
  return (
    <Spin spinning={isLoading}>
      <CreateNewDomainButton />
      <Tabs defaultActiveKey="1">
        <TabPane key="preWarmedUp" tab="Pre Warmed-up Domain">
          <PreWarmedUpDomain domains={preWarmedUpDomains} />
        </TabPane>
        <TabPane key="warmedUp" tab="Warmed-up Domain">
          <WarmedUpDomain
            domains={warmedUpDomains}
            key={JSON.stringify(percentageKey)}
          />
        </TabPane>
      </Tabs>
    </Spin>
  );
}

/**
 * Sort turing.com to the last (Insert turing.com if not available)
 * @param domains
 * @returns {[...*,{percentageDistribution: number, name: string, sgAccount: string, isWarmedUp: boolean, ipPool: string}]|*}
 */
function populateDefaultDomains(domains) {
  if (domains.find(e => e.name === 'turing.com')) {
    domains.sort((a, b) => {
      if (a.name === 'turing.com') return 1;
      if (b.name === 'turing.com') return -1;
      return 0;
    });
    return domains;
  }
  const warmedUpDomains = domains.filter(e => e.isWarmedUp),
    totalWarmedUpPercentage = warmedUpDomains.reduce(
      (acc, cur) => acc + cur.percentageDistribution,
      0,
    );
  return [
    ...domains,
    {
      isWarmedUp: true,
      name: 'turing.com',
      ipPool: 'turing',
      sgAccount: 'main',
      percentageDistribution: 1 - totalWarmedUpPercentage,
    },
  ];
}
